import { CartItem, CartItemSearch } from '@givebacks/api/store';
import { createColumnHelper } from 'core/Hooks';
import { createSearchFields } from 'core/Packages';

export const donationHistoryColumnHelper = createColumnHelper<CartItem>();

export const createDonationHistoryTableSearchFields = () => {
  return createSearchFields<CartItemSearch>([
    [
      'filter',
      [
        [
          'search',
          {
            fields: ['carts.name'],
            placeHolder: 'Search by donor name',
            label: 'Donor Name',
          },
        ],
        [
          'search',
          {
            fields: ['carts.email'],
            placeHolder: 'Search by donor email',
            label: 'Donor Email',
          },
        ],
        [
          'dateRange',
          {
            fields: ['carts.purchased_at'],
            placeHolder: 'Select date range',
            label: 'Purchase Date',
          },
        ],
        [
          'select',
          {
            fields: ['carts.status'],
            placeHolder: 'All',
            label: 'Payment Status',
            data: [
              { label: 'Purchased', value: 'purchased' },
              { label: 'Refunded', value: 'refunded' },
              { label: 'Partially Refunded', value: 'partially_refunded' },
              { label: 'Action Required', value: 'action_required' },
              { label: 'Disputed', value: 'disputed' },
              { label: 'Failed', value: 'failed' },
            ],
          },
        ],
      ],
    ],
  ]);
};
